import { useSelector } from "react-redux";

import { getDecodedToken, getToken } from "../store/authentication/selectors";

const useToken = ({ decoded = false } = {}) => useSelector(decoded ? getDecodedToken : getToken);

export default useToken;
